export const infoBubleMaxWidth = 300;
